import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { angRoutes } from '../constants/router';
import { AccessService } from '../services/access/access.service';

export const authGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const router = inject(Router);

  return accessService.isLoggedIn() ? true : router.createUrlTree([angRoutes.login.route]);
};
